/* eslint-disable */
import axios from "@/plugins/axios";
import store from "@/store";
const state = {
  categories: [],
  subCategories: [],
  links: [],
  roles: [
    { id: 1, value: "Аккаунт", text: "Аккаунт", active: false },
    { id: 2, value: "Проджект", text: "Проджект", active: false },
    { id: 3, value: "Специалист", text: "Специалист", active: false },
    { id: 4, value: "Лидер", text: "Лидер", active: false },
    { id: 5, value: "Стажер", text: "Стажер", active: false },
    { id: 6, value: "Топ-менеджер", text: "Топ-менеджер", active: false },
  ],
  selectedRole: "Аккаунт",
  typesCategories: [],
  typesSubCategories: []
};
const getters = {
  selectedRole: state => {
    return state.selectedRole;
  },
  categories: state => {
    return state.categories;
  },
  subCategories: state => {
    return state.subCategories;
  },
  links: state => {
    return state.links;
  },
  typesCategories: state => {
    return state.typesCategories;
  },
  typesSubCategories: state => {
    return state.typesSubCategories;
  },
  roles: state => {
    return state.roles;
  }
};
const mutations = {
  setCategories(state, payload) {
    state.categories = payload;
  },
  setTypesCategories(state, payload) {
    state.typesCategories = payload;
  },
  setSubCategories(state, payload) {
    state.subCategories = payload;
  },
  setTypesSubCategories(state, payload) {
    state.typesSubCategories = payload;
  },
  setLinks(state, payload) {
    state.links = payload;
  },
  updateCategories(state, payload) {
    state.categories.map(item => {
      if (item.id === payload.id) {
        item.text = payload.text;
      }
    });
  },
  updateSubCategories(state, payload) {
    state.subCategories.map(item => {
      if (item.id === payload.id) {
        item.text = payload.text;
      }
    });
  },
  removeElement(state, payload) {
    if (payload.name === "categories") {
      state.categories = state.categories.filter(
        item => item.id !== payload.id
      );
    } else if (payload.name === "subcategories") {
      const id = payload.id.subcat_id ? payload.id.subcat_id: payload.id
      state.subCategories = state.subCategories.filter(
        item => item.id !== id
      );
    } else if (payload.name === "links") {
      state.links = state.links.filter(item => item.id !== payload.id);
    }
  },
  setRole(state, payload) {
    state.selectedRole = payload;
  }
};
const actions = {
  async setUserAccess({}, payload) {
    await axios
      .post("/knowledge/users", payload)
      .then(res => {
        if (!res.data.payload) {
          $notify({ type: "warn", message: res.data.error });
        } else {   
          store.commit("app/setUsersList", res.data.payload.users);
          store.dispatch("user/getUserByToken");
          $notify({ type: "success", message: res.data.payload.message });
        }
      })
      .catch(error => {
        $notify({ type: "error", text: error });
      });
  },
  async removeUserAccess({}, payload) {
    await axios
      .put("/knowledge/users", payload)
      .then(res => {
        if (!res.data.payload) {
          $notify({ type: "warn", message: res.data.error });
        } else {
          store.commit("app/setUsersList", res.data.payload.users);
          store.dispatch("user/getUserByToken");
          $notify({ type: "success", message: res.data.payload.message });
        }
      })
      .catch(error => {
        $notify({ type: "error", text: error });
      });
  },
  async loadCategories({ commit, dispatch }) {
    await axios
      .get("/knowledge/categories")
      .then(res => {
        if (!res.data.payload) {
          $notify({ type: "warn", message: res.data.error });
        } else {
          dispatch("loadTypesCategories");
          commit("setCategories", res.data.payload.categories);
        }
      })
      .catch(error => {
        {
          $notify({ type: "error", text: error });
        }
      });
  },
  async loadTypesCategories({ commit }) {
    await axios
      .get("/knowledge/types-categories")
      .then(res => {
        if (!res.data.payload) {
          $notify({ type: "warn", message: res.data.error });
        } else {
          commit("setTypesCategories", res.data.payload.options);
        }
      })
      .catch(error => {
        {
          $notify({ type: "error", text: error });
        }
      });
  },
  async setCategory({ commit, dispatch }, payload) {
    await axios
      .post("/knowledge/categories", payload)
      .then(res => {
        if (!res.data.payload) {
          $notify({ type: "warn", message: res.data.error });
        } else {
          dispatch("loadTypesCategories");
          commit("setCategories", res.data.payload.categories);
          $notify({ type: "success", message: res.data.payload.message });
        }
      })
      .catch(error => {
        {
          $notify({ type: "error", text: error });
        }
      });
  },
  async updateCategories({ commit }, payload) {
    await axios
      .put("/knowledge/categories", payload)
      .then(res => {
        if (!res.data.payload) {
          $notify({ type: "warn", message: res.data.error });
        } else {
          commit("setCategories", res.data.payload.categories);
          $notify({ type: "success", message: res.data.payload.message });
        }
      })
      .catch(error => {
        $notify({ type: "error", text: error });
      });
  },
  async loadSubCategories({ commit, dispatch }) {
    await axios
      .get("/knowledge/subcategories")
      .then(res => {
        if (!res.data.payload) {
          $notify({ type: "warn", message: res.data.error });
        } else {
          dispatch("loadTypesSubCategories");
          commit("setSubCategories", res.data.payload.subCategories);
        }
      })
      .catch(error => {
        {
          $notify({ type: "error", text: error });
        }
      });
  },
  async loadTypesSubCategories({ commit }) {
    await axios
      .get("/knowledge/types-subcategories")
      .then(res => {
        if (!res.data.payload) {
          $notify({ type: "warn", message: res.data.error });
        } else {
          commit("setTypesSubCategories", res.data.payload.options);
        }
      })
      .catch(error => {
        {
          $notify({ type: "error", text: error });
        }
      });
  },
  async setSubCategory({ commit, dispatch }, payload) {
    await axios
      .post("/knowledge/subcategories", payload)
      .then(res => {
        if (!res.data.payload) {
          $notify({ type: "warn", message: res.data.error });
        } else {
          dispatch("loadTypesSubCategories");
          commit("setSubCategories", res.data.payload.subCategories);
          $notify({ type: "success", message: res.data.payload.message });
        }
      })
      .catch(error => {
        {
          $notify({ type: "error", text: error });
        }
      });
  },
  async updateSubCategories({ commit }, payload) {
    await axios
      .put("/knowledge/subcategories", payload)
      .then(res => {
        if (!res.data.payload) {
          $notify({ type: "warn", message: res.data.error });
        } else {
          commit("setSubCategories", res.data.payload.subCategories);
          $notify({ type: "success", message: res.data.payload.message });
        }
      })
      .catch(error => {
        $notify({ type: "error", text: error });
      });
  },
  async loadLinks({ commit }) {
    await axios
      .get("/knowledge/links")
      .then(res => {
        if (!res.data.payload) {
          $notify({ type: "warn", message: res.data.error });
        } else {
          commit("setLinks", res.data.payload.links);
        }
      })
      .catch(error => {
        {
          $notify({ type: "error", text: error });
        }
      });
  },
  async setLink({ commit }, payload) {
    await axios
      .post("/knowledge/links", payload)
      .then(res => {
        if (!res.data.payload) {
          $notify({ type: "warn", message: res.data.error });
        } else {
          commit("setLinks", res.data.payload.links);
          $notify({ type: "success", message: res.data.payload.message });
        }
      })
      .catch(error => {
        {
          $notify({ type: "error", text: error });
        }
      });
  },
  async updateLink({ commit }, payload) {
    await axios
      .put("/knowledge/links", payload)
      .then(res => {
        if (!res.data.payload) {
          $notify({ type: "warn", message: res.data.error });
        } else {
          commit("setLinks", res.data.payload.links);
          $notify({ type: "success", message: res.data.payload.message });
        }
      })
      .catch(error => {
        $notify({ type: "error", text: error });
      });
  },
  async removeElement({ commit, dispatch }, payload) {
    let url = payload.id.subcat_id ? payload.id.subcat_id : payload.id;
    await axios
      .delete(`/knowledge/${payload.name}/${url}`, { data: {data: payload.id} })
      .then(res => {
        if (!res.data.payload) {
          $notify({ type: "warn", message: res.data.error });
        } else {
          $notify({ type: "success", message: res.data.payload });
          commit("removeElement", payload);
          if (payload.name === "categories") {
            dispatch("loadTypesCategories");
          } else if (payload.name === "subcategories") {
            dispatch("loadTypesSubCategories");
            dispatch("loadLinks");
          }
        }
      })
      .catch(error => {
        $notify({ type: "error", text: error });
      });
  },
  setRole({ commit }, payload) {
    commit("setRole", payload);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
